import sigloNetAxiosInstance from '@/utils/sigloNetAxios'

export default {
  namespaced: true,
  state: {
    paymentTypes: {
      spidAccountTypeId: {
        display: false,
        value: 0,
      },
      spidAccountTypeCode: {
        display: true,
        value: '',
        type: 'input',
        label: 'code',
      },
      spidAccountTypeName: {
        display: true,
        value: '',
        type: 'input',
        label: 'description',
      },
      isActive: {
        display: true,
        value: true,
        type: 'checkbox',
        label: 'active',
      },
      version: {
        display: false,
        value: '',
        type: '',
      },
    },
  },
  getters: {
    paymentTypes(state) {
      return state.paymentTypes
    },
  },
  mutations: {},
  actions: {
    getAccountTypes(
      _,
      {
        perPage, currentPage, filterByProductCode, orderBy = null,
      },
    ) {
      return new Promise((resolve, reject) => {
        sigloNetAxiosInstance
          .get('/spid_account_types', {
            params: {
              PerPage: perPage,
              CurrentPage: currentPage,
              filterByIsActive: null,
              FilterByProductCode: filterByProductCode,
              OrderBy: orderBy,
            },
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    fetchPaymentTypeById(_, { id }) {
      return new Promise((resolve, reject) => {
        sigloNetAxiosInstance
          .get(`/spid_account_types/${id}`)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    savePaymentType(_, { data }) {
      return new Promise((resolve, reject) => {
        sigloNetAxiosInstance
          .post('/spid_account_types', data)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    updatePaymentType(_, { data }) {
      return new Promise((resolve, reject) => {
        sigloNetAxiosInstance
          .put('/spid_account_types', data)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
